const makeConstant = constant => `meeting/${constant}`

export const FETCH_CALENDAR_STATUS = makeConstant('FETCH_CALENDAR_STATUS')
export const FETCH_CALENDAR_STATUS_PENDING = makeConstant('FETCH_CALENDAR_STATUS_PENDING')
export const FETCH_CALENDAR_STATUS_SUCCESS = makeConstant('FETCH_CALENDAR_STATUS_SUCCESS')
export const FETCH_CALENDAR_STATUS_FAILURE = makeConstant('FETCH_CALENDAR_STATUS_FAILURE')

export const FETCH_GOOGLE_CALENDARS = makeConstant('FETCH_GOOGLE_CALENDARS')
export const FETCH_GOOGLE_CALENDARS_PENDING = makeConstant('FETCH_GOOGLE_CALENDARS_PENDING')
export const FETCH_GOOGLE_CALENDARS_SUCCESS = makeConstant('FETCH_GOOGLE_CALENDARS_SUCCESS')
export const FETCH_GOOGLE_CALENDARS_FAILURE = makeConstant('FETCH_GOOGLE_CALENDARS_FAILURE')

export const UPDATE_GOOGLE_CALENDAR = makeConstant('UPDATE_GOOGLE_CALENDAR')
export const UPDATE_GOOGLE_CALENDAR_PENDING = makeConstant('UPDATE_GOOGLE_CALENDAR_PENDING')
export const UPDATE_GOOGLE_CALENDAR_SUCCESS = makeConstant('UPDATE_GOOGLE_CALENDAR_SUCCESS')
export const UPDATE_GOOGLE_CALENDAR_FAILURE = makeConstant('UPDATE_GOOGLE_CALENDAR_FAILURE')

export const FETCH_MICROSOFT_CALENDARS = makeConstant('FETCH_MICROSOFT_CALENDARS')
export const FETCH_MICROSOFT_CALENDARS_PENDING = makeConstant('FETCH_MICROSOFT_CALENDARS_PENDING')
export const FETCH_MICROSOFT_CALENDARS_SUCCESS = makeConstant('FETCH_MICROSOFT_CALENDARS_SUCCESS')
export const FETCH_MICROSOFT_CALENDARS_FAILURE = makeConstant('FETCH_MICROSOFT_CALENDARS_FAILURE')

export const UPDATE_MICROSOFT_CALENDAR = makeConstant('UPDATE_MICROSOFT_CALENDAR')
export const UPDATE_MICROSOFT_CALENDAR_PENDING = makeConstant('UPDATE_MICROSOFT_CALENDAR_PENDING')
export const UPDATE_MICROSOFT_CALENDAR_SUCCESS = makeConstant('UPDATE_MICROSOFT_CALENDAR_SUCCESS')
export const UPDATE_MICROSOFT_CALENDAR_FAILURE = makeConstant('UPDATE_MICROSOFT_CALENDAR_FAILURE')

export const UPDATE_MEETING_SETTINGS_SUCCESS = makeConstant('UPDATE_MEETING_SETTINGS_SUCCESS')
export const UPDATE_MEETING_SETTINGS_FAILURE = makeConstant('UPDATE_MEETING_SETTINGS_FAILURE')

export const FETCH_DEFAULT_MEETING_SETTINGS = makeConstant('FETCH_DEFAULT_MEETING_SETTINGS')
export const FETCH_DEFAULT_MEETING_SETTINGS_PENDING = makeConstant('FETCH_DEFAULT_MEETING_SETTINGS_PENDING')
export const FETCH_DEFAULT_MEETING_SETTINGS_SUCCESS = makeConstant('FETCH_DEFAULT_MEETING_SETTINGS_SUCCESS')
export const FETCH_DEFAULT_MEETING_SETTINGS_FAILURE = makeConstant('FETCH_DEFAULT_MEETING_SETTINGS_FAILURE')

export const UPDATE_DEFAULT_MEETING_SETTINGS = makeConstant('UPDATE_DEFAULT_MEETING_SETTINGS')
export const UPDATE_DEFAULT_MEETING_SETTINGS_PENDING = makeConstant('UPDATE_DEFAULT_MEETING_SETTINGS_PENDING')
export const UPDATE_DEFAULT_MEETING_SETTINGS_SUCCESS = makeConstant('UPDATE_DEFAULT_MEETING_SETTINGS_SUCCESS')
export const UPDATE_DEFAULT_MEETING_SETTINGS_FAILURE = makeConstant('UPDATE_DEFAULT_MEETING_SETTINGS_FAILURE')



// WEBPACK FOOTER //
// ./src/modules/meetings/constants.js